import { render, staticRenderFns } from "./OrderPrintItem.vue?vue&type=template&id=56f98442&scoped=true"
import script from "./OrderPrintItem.vue?vue&type=script&lang=js"
export * from "./OrderPrintItem.vue?vue&type=script&lang=js"
import style0 from "./OrderPrintItem.vue?vue&type=style&index=0&id=56f98442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f98442",
  null
  
)

export default component.exports